import React, { useEffect, useMemo, useState } from 'react';
import { Box, Button, Typography } from '@mui/material';
import useWipFirestoreStock, { WipStockContext } from '../../hooks/useWipFirestoreStock';
import LowCare from './LowCare';
import StockTablePage from '../../components/monitor/StockTablePage';

export const monitorPages = items => [
  ...(items.length ? ['Warehouse'] : []),
  ...['RAW MAT', 'WIP', 'FG'].filter(category => items.some(item => item.category === category)),
];

export default function InlineMonitor() {
  const stock = useWipFirestoreStock();
  const [care, setCare] = useState('Low care');
  const [running, setRunning] = useState(true);
  const [page, setPage] = useState('Warehouse');
  const zone = care === 'Low care' ? 'ดิบ' : 'สุก';
  const items = useMemo(() => zone ? stock.items.filter(item => item.zone === zone) : [], [stock.items, zone]);
  const pages = useMemo(() => monitorPages(items), [items]);
  const key = pages.join('|');
  const active = pages.includes(page) ? page : pages[0];
  useEffect(() => {
    if (!running || pages.length < 2) return undefined;
    const timer = setInterval(() => setPage(current => {
      const index = pages.indexOf(current);
      return pages[(index + 1) % pages.length];
    }), 15000);
    return () => clearInterval(timer);
  }, [running, key, care, zone]);
  const provided = { ...stock, items };
  return <Box sx={{ bgcolor: '#0e161e', color: '#edf4f7', p: 2 }}>
    <Box sx={{ display: 'flex', alignItems: 'center', gap: 2, flexWrap: 'wrap', mb: 1 }}>
      <Typography component="h1" sx={{ fontSize: 26 }}>In-Line Monitor</Typography>
      {['Low care', 'High care'].map(value => <Button key={value} variant={care === value ? 'contained' : 'outlined'}
        onClick={() => { setCare(value); setPage('Warehouse'); setRunning(true); }}>{value}</Button>)}
      <Typography sx={{ color: '#bdcbd6' }}>โซน{zone} · สลับทุก 15 วินาที</Typography>
      <Button disabled={!zone || !pages.length} onClick={() => setRunning(value => !value)}>{running ? 'หยุดสลับ' : 'เริ่มสลับทุก 15 วินาที'}</Button>
    </Box>
    {stock.error ? <Typography role="alert">{stock.error}</Typography>
      : stock.loading ? <Typography>กำลังโหลดข้อมูล...</Typography>
      : !pages.length ? <Typography>ไม่มีข้อมูลในโซนที่เลือก ระบบจะรอข้อมูลใหม่</Typography>
      : <WipStockContext.Provider value={provided}>
        <Typography sx={{ color: '#75cbd0' }}>{care} · {zone} · {active === 'RAW MAT' ? 'Raw Mat' : active} · {pages.indexOf(active) + 1}/{pages.length}</Typography>
        {active === 'Warehouse' ? <LowCare embedded /> : <StockTablePage title={active} category={active} embedded />}
      </WipStockContext.Provider>}
  </Box>;
}
